import { Component } from 'react';
import {Col, Row} from 'react-bootstrap';
import moment from 'moment/moment';
import BsCheckbox from '../../common/form/elements/bs-checkbox';

class MessageHeader extends Component {
  onMessageChecked = (event, id) => this.props.onMessageChecked(id, event.target.checked);

  render() {
    const {checked, message, checkbox} = this.props;

    const createdAt = moment(message.attributes['created-at'])
      .format('DD/MM/YYYY');

    return (
      <Row>
        <Col lg={12}>
          {createdAt}
          {checkbox && (
          <BsCheckbox
            inline
            checked={checked}
            onChange={e => this.onMessageChecked(e, message.id)}
            className="float-end check-message"
          />
)}
        </Col>
      </Row>
    );
  }
}

export default MessageHeader;
